import React, { useState, useEffect } from "react";
import homePageStyles from "../../common/styles/HomePage";
import {
  List,
  ListItem,
  Divider,
  ListItemSecondaryAction,
  GTIWebStatus,
  GTIWebButton
} from "@gti-controls-v2/web-core";

const ListCardResult = ({ dataSet, handleClick }) => {
  const styles = homePageStyles;
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (Array.isArray(dataSet) && dataSet.length > 0) {
      setItems(dataSet);
    } else {
      setItems([]);
    }
  }, [dataSet]);

  const CustomStatusContent = ({ value }) => (
    <GTIWebStatus
      label={value ? "Confirmado" : "No Confirmado"}
      status={value}
      statusList = {value === 2 }
      datasource={styles.status}
    />
  );

  return (
    <div>
      <List component="nav">
        {items.map((item, i) => (
          <div
            key={i}
            style={{
              background: "#fff",
              borderLeft: "2px solid #eee",
              borderRight: "2px solid #eee"
            }}
          >
            <Divider />
            <ListItem button style={{ padding: "16.5px" }}>
              <div>
                <strong style={{ fontSize: "14px" }}>{item.label}</strong>
                {(item.status || (item.value && item.button)) && (
                  <CustomStatusContent value={item.status} />
                )}
                <div style={{ fontSize: "14px", color: "#333" }}>
                {item.value ? item.value : "\u00A0"}
                </div>
              </div>
              <ListItemSecondaryAction>
                {item.value && item.button ? (
                  <GTIWebButton
                    name={"ListCardBtn" + i}
                    type="submit"
                    text={item.button}
                    sx={homePageStyles.btnSecondary}
                    onClick={(e) => handleClick(e, item.buttonId)}
                  />
                ) : (
                  <div style={{ width: "120px" }} /> 
                )}
              </ListItemSecondaryAction>
            </ListItem>
          </div>
        ))}
      </List>
    </div>
  );
};

export default ListCardResult;
